<template>
    <v-container fluid>
        
                <ProductsInHopperItem
                    v-for="i in Array.from(Array(device.hoppersCount), (e,i)=> i + 1)"
                    :key="i"
                    :hopper-number="i"
                    :device="device"
                    :products="products"
                    v-on:changed="(items) => $emit('changed', i, items)"
                />
    </v-container>
</template>

<script>
import ProductsInHopperItem from '@/components/ProductsInHopperItem';

export default {
  name: 'ManageDeviceProductsList',
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      products: [],
      hoppers:[],
      selectedProducts: Array.from(Array(this.device.hoppersCount), () => [])
    };
  },
  mounted() {
    this.setHoppers();
    this.$axios.products.getAvailableForDevice(this.device.deviceId)
      .then(response => response.data)
      .then(json =>
      {
        this.products = json;
      });
  },
  methods: {
    setHoppers(){
      this.hoppers = [];
      for(var i = 0; i < this.device.hoppersCount; i++)
        this.hoppers.push(i);
    }
  },
  components: {ProductsInHopperItem},
};
</script>
